import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';

import App from './App.vue';
import router from './router';

import 'sweetalert2/dist/sweetalert2.min.css';
import '@/assets/css/tailwind.css';
import store from './store';

Vue.use(VueSweetalert2);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
